import { GeneralService } from './../../../services/general.service';
import { FormGroup, Validators } from '@angular/forms';

export class FormCd001LimpezaBuild {

    public async buildForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): Promise<FormGroup> {
        form = await this.buildFormI(form, arrForm[0], generalService);
        form = await this.buildFormII(form, arrForm[1], generalService);
        form = await this.buildFormIII(form, arrForm[2], generalService);
        form = await this.buildFormIV(form, arrForm[3], generalService);
        form = await this.buildFormV(form, arrForm[4], generalService);
        return form;
    }

    private async buildFormI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('site').setValue(formCard.get('site')?.value ?? null);
        form.get('data_hora').setValue(generalService.createDateTimeData(formCard.get('data')?.value, formCard.get('hora')?.value));
        form.get('numero_controle').setValue(formCard.get('numero_controle')?.value ?? null);
        form.get('hibrido').setValue(formCard.get('hibrido')?.value ?? null);
        form.get('processo').setValue(formCard.get('processo')?.value ?? null);
        form.get('lote_origem').setValue(formCard.get('lote_origem')?.value ?? null);
        form.get('deposito_origem').setValue(formCard.get('deposito_origem')?.value ?? null);
        form.get('umidade_ds_prc').setValue(formCard.get('umidade_ds_prc')?.value ?? null);
        // tslint:disable-next-line: max-line-length
        form.get('safra').setValue(formCard.get('safra')?.value ?? null);
        // tslint:disable-next-line: max-line-length
        form.get('peneira_topo').setValue(formCard.get('peneira_topo')?.value ?? null);
        form.get('peneira_fundo').setValue(formCard.get('peneira_fundo')?.value ?? null);
        form.get('peneira_intermediaria').setValue(formCard.get('peneira_intermediaria')?.value ?? null);
        form.get('basic').setValue(formCard.get('basic')?.value ?? null);
        form.get('numero_campo').setValue(formCard.get('numero_campo')?.value ?? null);
        form.get('ajuste_1').setValue(formCard.get('ajuste_1')?.value ?? null);
        form.get('ajuste_2').setValue(formCard.get('ajuste_2')?.value ?? null);
        form.get('ajuste_3').setValue(formCard.get('ajuste_3')?.value ?? null);
        form.get('ajuste_4').setValue(formCard.get('ajuste_4')?.value ?? null);
        form.get('ajuste_5').setValue(formCard.get('ajuste_5')?.value ?? null);
        form.get('ajuste_6').setValue(formCard.get('ajuste_6')?.value ?? null);
        form.get('turno').setValue(formCard.get('turno')?.value ?? null);


        return await form;
    }

    private async buildFormII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('peso_amostra_dez_segundos_kg').setValue(formCard.get('peso_amostra_dez_segundos_kg')?.value ?? null);
        form.get('peso_amostra_cinco_segundos_kg').setValue(formCard.get('peso_amostra_cinco_segundos_kg')?.value ?? null);
        form.get('vazao_processo_th').setValue(formCard.get('vazao_processo_th')?.value ?? null);
        return await form;
    }

    private async buildFormIII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('peso_amostra_trinta_segundos_g').setValue(formCard.get('peso_amostra_trinta_segundos_g')?.value ?? null);
        form.get('peso_fracao_analise_g').setValue(formCard.get('peso_fracao_analise_g')?.value ?? null);
        form.get('peso_semente_boa_descarte_g').setValue(formCard.get('peso_semente_boa_descarte_g')?.value ?? null);
        form.get('descarte_total_pre_limpeza_prc').setValue(formCard.get('descarte_total_pre_limpeza_prc')?.value ?? null);
        form.get('perda_semente_boa_descarte_prc').setValue(formCard.get('perda_semente_boa_descarte_prc')?.value ?? null);
        form.get('perda_descarte_prc').setValue(formCard.get('perda_descarte_prc')?.value ?? null);
        // form.get('total_defeitos_prc').setValue(formCard.get('total_defeitos_prc')?.value?? null);
        // form.get('total_defeitos_g').setValue(formCard.get('total_defeitos_g')?.value?? null);
        //  form.get('peso_hectolitrico_fracao_boa').setValue(formCard.get('peso_hectolitrico_fracao_boa')?.value?? null);
        //  form.get('peso_hectolitrico_fracao_descarte').setValue(formCard.get('peso_hectolitrico_fracao_descarte')?.value?? null);
        //  form.get('diferenca_peso_hectolitrico').setValue(formCard.get('diferenca_peso_hectolitrico')?.value?? null);
        form.get('peso_pre_pos_succsao').setValue(formCard.get('peso_pre_pos_succsao')?.value ?? null);
        form.get('peso_topo_fundo_30s').setValue(formCard.get('peso_topo_fundo_30s')?.value ?? null);

        form.get('descarte_kg_h').setValue(formCard.get('descarte_kg_h')?.value ?? null);
        return await form;
    }

    private async buildFormIV(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('presenca_sabugo_pedunculo').setValue(formCard.get('presenca_sabugo_pedunculo')?.value ?? null);
        form.get('presenca_fundo').setValue(formCard.get('presenca_fundo')?.value ?? null);
        form.get('presenca_po_excesso').setValue(formCard.get('presenca_po_excesso')?.value ?? null);
        form.get('presenca_outros_cultivares').setValue(formCard.get('presenca_outros_cultivares')?.value ?? null);
        form.get('total_defeitos_prc').setValue(formCard.get('total_defeitos_prc')?.value ?? null);
        form.get('total_defeitos_g').setValue(formCard.get('total_defeitos_g')?.value ?? null);
        form.get('peso_hectolitrico_fracao_boa').setValue(formCard.get('peso_hectolitrico_fracao_boa')?.value ?? null);
        form.get('peso_hectolitrico_fracao_descarte').setValue(formCard.get('peso_hectolitrico_fracao_descarte')?.value ?? null);
        form.get('diferenca_peso_hectolitrico').setValue(formCard.get('diferenca_peso_hectolitrico')?.value ?? null);
        form.get('resultado').setValue(formCard.get('resultado')?.value ?? null);
        form.get('existe_descarte_massa_boa').setValue(formCard.get('existe_descarte_massa_boa')?.value ?? null);
        return await form;
    }

    private async buildFormV(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('created_by').setValue(formCard.get('criado_por')?.value ?? null);
        form.get('usuario').setValue(formCard.get('usuario')?.value ?? null);
        form.get('observacoes').setValue(formCard.get('observacoes')?.value ?? null);
        return await form;
    }

    public async updateForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): Promise<void> {
        await this.updateFormI(form, arrForm[0], generalService);
        await this.updateFormII(form, arrForm[1], generalService);
        await this.updateFormIII(form, arrForm[2], generalService);
        await this.updateFormIV(form, arrForm[3], generalService);
        await this.updateFormV(form, arrForm[4], generalService);
    }

    private async updateFormI(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        formCard.get('site')?.setValue(data.formulario.site);
        // tslint:disable-next-line: max-line-length
        formCard.get('data')?.setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.data_hora, true));
        // tslint:disable-next-line: max-line-length
        formCard.get('hora')?.setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.data_hora, false));
        formCard.get('numero_controle')?.setValue(data.formulario.numero_controle);
        formCard.get('hibrido')?.setValue(data.formulario.hibrido);
        formCard.get('processo')?.setValue(data.formulario.processo);
        formCard.get('lote_origem')?.setValue(data.formulario.lote_origem);
        formCard.get('deposito_origem')?.setValue(data.formulario.deposito_origem);
        formCard.get('umidade_ds_prc')?.setValue(data.formulario.umidade_ds_prc);
        formCard.get('safra')?.setValue(data.formulario.safra);
        formCard.get('peneira_topo')?.setValue(data.formulario.peneira_topo);
        formCard.get('peneira_fundo')?.setValue(data.formulario.peneira_fundo);
        formCard.get('peneira_intermediaria')?.setValue(data.formulario.peneira_intermediaria);
        formCard.get('basic')?.setValue(data.formulario.basic);
        formCard.get('numero_campo')?.setValue(data.formulario.numero_campo);
        formCard.get('ajuste_1')?.setValue(data.formulario.ajuste_1);
        formCard.get('ajuste_2')?.setValue(data.formulario.ajuste_2);
        formCard.get('ajuste_3')?.setValue(data.formulario.ajuste_3);
        formCard.get('ajuste_4')?.setValue(data.formulario.ajuste_4);
        formCard.get('ajuste_5')?.setValue(data.formulario.ajuste_5);
        formCard.get('ajuste_6')?.setValue(data.formulario.ajuste_6);
        formCard.get('turno')?.setValue(data.formulario.turno);

    }

    private async updateFormII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        formCard.get('peso_amostra_dez_segundos_kg')?.setValue(data.formulario.peso_amostra_dez_segundos_kg);
        formCard.get('peso_amostra_cinco_segundos_kg')?.setValue(data.formulario.peso_amostra_cinco_segundos_kg);
        formCard.get('vazao_processo_th')?.setValue(data.formulario.vazao_processo_th);
    }

    private async updateFormIII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        formCard.get('peso_amostra_trinta_segundos_g')?.setValue(data.formulario.peso_amostra_trinta_segundos_g);
        formCard.get('peso_fracao_analise_g')?.setValue(data.formulario.peso_fracao_analise_g);
        formCard.get('peso_semente_boa_descarte_g')?.setValue(data.formulario.peso_semente_boa_descarte_g);
        formCard.get('descarte_total_pre_limpeza_prc')?.setValue(data.formulario.descarte_total_pre_limpeza_prc);
        formCard.get('perda_semente_boa_descarte_prc')?.setValue(data.formulario.perda_semente_boa_descarte_prc);
        formCard.get('perda_descarte_prc')?.setValue(data.formulario.perda_descarte_prc);
        //  formCard.get('total_defeitos_prc')?.setValue(data.formulario.total_defeitos_prc);
        //  formCard.get('total_defeitos_g')?.setValue(data.formulario.total_defeitos_g);
        // tslint:disable-next-line: max-line-length
        //  formCard.get('peso_hectolitrico_fracao_boa')?.setValue(data.formulario.peso_hectolitrico_fracao_boa);
        // tslint:disable-next-line: max-line-length
        // formCard.get('peso_hectolitrico_fracao_descarte')?.setValue(data.formulario.peso_hectolitrico_fracao_descarte);
        // formCard.get('diferenca_peso_hectolitrico')?.setValue(data.formulario.diferenca_peso_hectolitrico);
        formCard.get('peso_pre_pos_succsao')?.setValue(data.formulario.peso_pre_pos_succsao);
        formCard.get('peso_topo_fundo_30s')?.setValue(data.formulario.peso_topo_fundo_30s);
        formCard.get('descarte_kg_h')?.setValue(data.formulario.descarte_kg_h);
    }

    private async updateFormIV(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        formCard.get('presenca_sabugo_pedunculo')?.setValue(data.formulario.presenca_sabugo_pedunculo);
        formCard.get('presenca_fundo')?.setValue(data.formulario.presenca_fundo);
        formCard.get('presenca_po_excesso')?.setValue(data.formulario.presenca_po_excesso);
        formCard.get('presenca_outros_cultivares')?.setValue(data.formulario.presenca_outros_cultivares);
        formCard.get('total_defeitos_prc')?.setValue(data.formulario.total_defeitos_prc);
        formCard.get('total_defeitos_g')?.setValue(data.formulario.total_defeitos_g);
        formCard.get('peso_hectolitrico_fracao_boa')?.setValue(data.formulario.peso_hectolitrico_fracao_boa);
        formCard.get('peso_hectolitrico_fracao_descarte')?.setValue(data.formulario.peso_hectolitrico_fracao_descarte);
        formCard.get('diferenca_peso_hectolitrico')?.setValue(data.formulario.diferenca_peso_hectolitrico);
        formCard.get('resultado')?.setValue(data.formulario.resultado);
        formCard.get('existe_descarte_massa_boa')?.setValue(data.formulario.existe_descarte_massa_boa);

    }

    private async updateFormV(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        formCard.get('criado_por')?.setValue(data.formulario.created_by);
        formCard.get('usuario')?.setValue(data.formulario.usuario);
        formCard.get('observacoes')?.setValue(data.formulario.observacoes);
    }
}
